// components/VehicleFields.tsx
import React from "react";
import { TextField, Stack } from "@mui/material";
import { useFormikContext } from "formik";

export type VehicleFormValues = {
  licensePlateNumber: string;
  make: string;
  model: string;
  color: string;
  vin: string;
  engineNumber : string;
};


const VehicleFields: React.FC = () => {
  const { values, errors, touched, handleChange, handleBlur } =
    useFormikContext<VehicleFormValues>();

  return (
    <Stack spacing={2}>
      <TextField
        label="License Plate Number"
        name="licensePlateNumber"
        value={values.licensePlateNumber ?? ""}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        fullWidth
        error={Boolean(touched.licensePlateNumber && errors.licensePlateNumber)}
        helperText={touched.licensePlateNumber && errors.licensePlateNumber}
      />
      <TextField
        label="Make"
        name="make"
        value={values.make ?? ""}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        fullWidth
        error={Boolean(touched.make && errors.make)}
        helperText={touched.make && errors.make}
      />
      <TextField
        label="Model"
        name="model"
        value={values.model ?? ""}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        fullWidth
        error={Boolean(touched.model && errors.model)}
        helperText={touched.model && errors.model}
      />
      <TextField
        label="Color"
        name="color"
        value={values.color ?? ""}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        fullWidth
        error={Boolean(touched.color && errors.color)}
        helperText={touched.color && errors.color}
      />
      <TextField
        label="Vin"
        name="vin"
        value={values.vin ?? ""}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        fullWidth
        error={Boolean(touched.vin && errors.vin)}
        helperText={touched.vin && errors.vin}
      />
      <TextField
        label="Engine Number"
        name="engineNumber"
        value={values.engineNumber ?? ""}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        fullWidth
        error={Boolean(touched.engineNumber && errors.engineNumber)}
        helperText={touched.engineNumber && errors.engineNumber}
      />
    </Stack>
  );
};

export default VehicleFields;
